/* global pca */
/* global CheckoutValidation */

const AddressAutocomplete = {

    init(key, country) {
        if (typeof pca === "undefined") return;
        let search_field = document.getElementById("autocomplete_search");

        if (typeof(search_field) === 'undefined' || search_field == null) {
            // No search field exists, skip init
            return;
        }

        let fields = [
            { element: search_field.id, field: "", mode: pca.fieldMode.SEARCH },

            { element: "street-address", field: "Line1", mode: pca.fieldMode.POPULATE },
            { element: "street-address2", field: "Line2", mode: pca.fieldMode.POPULATE },
            { element: "city", field: "City", mode: pca.fieldMode.POPULATE },
            { element: "state", field: "ProvinceName", mode: pca.fieldMode.POPULATE },
            { element: "province", field: "ProvinceName", mode: pca.fieldMode.POPULATE },
            { element: "postal_code", field: "PostalCode", mode: pca.fieldMode.POPULATE },
            { element: "country", field: "CountryName", mode: pca.fieldMode.COUNTRY },

            { element: "multi-unit", field: "{AcMua}", mode: pca.fieldMode.POPULATE },
            { element: "residential-business", field: "{AcRbdi}", mode: pca.fieldMode.POPULATE }
        ],
        options = {
            key: key,
            bar: {
                showCountry: false,
                showLogo: true,
                logoLink: false
            }
        },
        control = new pca.Address(fields, options);

        // Set country for US
        if (country === 'US') {
            control.setCountry("United States");
        }

        // Triggered when Canada Post populates address fields
        control.listen("populate", (address) => {
            // Format zip code
            if (country === 'US' && address.PostalCode.length > 5) {
                address.PostalCode = address.PostalCode.substring(0,5);
                document.getElementById('postal_code').value = address.PostalCode;
            }

            // Put full address in search bar
            this.populateSearchField("", address.Line1, address.City, address.ProvinceName, address.PostalCode);

            // Calculate building_type
            let res = document.getElementById('residential-business').value;
            let units = document.getElementById('multi-unit').value;
            if (res === 'B') {
                document.getElementById('building_type').value = 'Office';
            }
            else if (units === '0') {
                document.getElementById('building_type').value = 'House'
            }
            else {
                document.getElementById('building_type').value = 'Apartment'
            }
            try {
                CheckoutValidation.toggleFields();
            } catch (e) {
                console.log('toggleFields removed');
            }

            this.populateBillingFields();
        });

        search_field.addEventListener('blur', () => {
            if (document.getElementById('street-address').value !== "") {
                // Format zip code
                if (country === 'US' && document.getElementById('postal_code').value.length > 5) {
                    document.getElementById('postal_code').value = document.getElementById('postal_code').value.substring(0,5);
                }

                this.populateSearchField(
                    "",
                    document.getElementById('street-address').value,
                    document.getElementById('city').value,
                    document.getElementById('province').value,
                    document.getElementById('postal_code').value
                );
            }
        });


        if (search_field.length) {
            search_field.addEventListener('change', () => {
                document.getElementById('street-address').value = '';
                document.getElementById('street-address2').value = '';
                document.getElementById('city').value = '';
                document.getElementById('state').value = '';
                document.getElementById('province').value = '';
                document.getElementById('postal_code').value = '';
                document.getElementById('country').value = '';
                document.getElementById('multi-unit').value = '';
                document.getElementById('residential-business').value = '';
                document.getElementById('building_type').value = '';
            });
        }
    },

    init_billing(key, country) {
        if (typeof pca === "undefined") return;
        let search_field = document.getElementById("billing-autocomplete_search");

        if (typeof(search_field) === 'undefined' || search_field == null) {
            // No search field exists, skip init
            return;
        }

        let fields = [
            { element: search_field.id, field: "", mode: pca.fieldMode.SEARCH },

            { element: "billing-street-address", field: "Line1", mode: pca.fieldMode.POPULATE },
            { element: "billing-city", field: "City", mode: pca.fieldMode.POPULATE },
            { element: "billing-province", field: "ProvinceName", mode: pca.fieldMode.POPULATE },
            { element: "billing-postal_code", field: "PostalCode", mode: pca.fieldMode.POPULATE },
        ],
        options = {
            key: key,
            bar: {
                showCountry: false,
                showLogo: true,
                logoLink: false
            }
        },
        control = new pca.Address(fields, options);

        // Set country for US
        if (country === 'US') {
            control.setCountry("United States");
        }

        // Triggered when Canada Post populates address fields
        control.listen("populate", (address) => {
            // Format zip code
            if (country === 'US' && address.PostalCode.length > 5) {
                address.PostalCode = address.PostalCode.substring(0,5);
                document.getElementById('billing-postal_code').value = address.PostalCode;
            }

            // Put full address in search bar
            this.populateSearchField("billing-", address.Line1, address.City, address.ProvinceName, address.PostalCode);

            try {
                CheckoutValidation.toggleFields("billing-");
            } catch (e) {
                console.log('toggleFields removed');
            }
        });

        search_field.addEventListener('blur', () => {
            if (document.getElementById('billing-street-address').value !== "") {
                // Format zip code
                if (country === 'US' && document.getElementById('billing-postal_code').value.length > 5) {
                    document.getElementById('billing-postal_code').value = document.getElementById('billing-postal_code').value.substring(0,5);
                }

                this.populateSearchField(
                    "billing-",
                    document.getElementById('billing-street-address').value,
                    document.getElementById('billing-city').value,
                    document.getElementById('billing-province').value,
                    document.getElementById('billing-postal_code').value
                );
            }
        });


        if (search_field.length) {
            search_field.addEventListener('change', () => this.clearBillingFields());
        }

        this.billing_same_as_shipping();
    },

    populateBillingFields() {
        let sameAsShipping = document.getElementById('same_as_shipping-checkbox');
        if (sameAsShipping && sameAsShipping.checked) {
            let address = document.getElementById('street-address').value;
            let city = document.getElementById('city').value;
            let province = document.getElementById('province').value;
            let postal = document.getElementById('postal_code').value;

            document.getElementById('billing-street-address').value = address;
            document.getElementById('billing-city').value = city;
            document.getElementById('billing-province').value = province
            document.getElementById('billing-postal_code').value = postal

            document.getElementById('shipping-summation-street-address').innerHTML = address;
            document.getElementById('shipping-summation-city').innerHTML = city;
            document.getElementById('shipping-summation-province').innerHTML = province
            document.getElementById('shipping-summation-postal_code').innerHTML = postal
        }
    },

    clearBillingFields(){
        document.getElementById('billing-street-address').value = '';
        document.getElementById('billing-city').value = '';
        document.getElementById('billing-province').value = '';
        document.getElementById('billing-postal_code').value = '';
    },

    populateSearchField(prefix, address, city, province, postal_code) {
        let search_field = document.getElementById(prefix + "autocomplete_search");
        if (search_field) {
            search_field.value = address + ", " + city + ", " + province + " " + postal_code;
        }
    },

    billing_same_as_shipping() {
        let sameAsShipping = document.getElementById('same_as_shipping-checkbox');
        if (sameAsShipping.checked) {
            document.getElementById('billing_address').style.display = "none";
            document.getElementById('shipping_summation').style.display = "block";
            document.getElementById('billing-autocomplete_search').value = document.getElementById('autocomplete_search').value;
            this.populateBillingFields();
        } else {
            this.clearBillingFields();
            document.getElementById('billing_address').style.display = "block";
            document.getElementById('shipping_summation').style.display = "none";
        }
    }
};

export default AddressAutocomplete;